import { Link, useLocation, matchPath } from 'react-router-dom';

// material-ui
import Box from '@mui/material/Box';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';

// project import
import { ThemeMode } from 'config';
import useConfig from 'hooks/useConfig';

// types
import { LinkTarget, NavItemType } from 'types/menu';

// ==============================|| NAVIGATION - LIST ITEM ||============================== //

interface Props {
  item: NavItemType;
  level: number;
  isParents?: boolean;
}

export default function NavItem({ item, level, isParents = false }: Props) {
  const { mode } = useConfig();
  let itemTarget: LinkTarget = '_self';
  if (item.target) {
    itemTarget = '_blank';
  }

  const { pathname } = useLocation();
  const isSelected = !!matchPath({ path: item?.link ? item.link : item.url!, end: false }, pathname);

  const textColor = mode === ThemeMode.DARK ? 'grey.400' : 'text.secondary';
  const iconSelectedColor = mode === ThemeMode.DARK ? 'secondary.main' : 'secondary.main';

  return (
    <>
      <Box sx={{ position: 'relative' }}>
        <ListItemButton
          component={Link}
          to={item.url!}
          target={itemTarget}
          disabled={item.disabled}
          selected={isSelected}
          sx={{
            zIndex: 1201,
            pl: 1.5,
            py: level === 1 ? 1.25 : 1,
            '&:hover': { bgcolor: mode === ThemeMode.DARK ? 'divider' : 'secondary.main' },
            '&.Mui-selected': {
              bgcolor: mode === ThemeMode.DARK ? 'divider' : 'secondary',
              borderRight: '2px solid',
              borderColor: 'secondary.main',
              color: 'secondary.main',
              '&:hover': { color: iconSelectedColor, bgcolor: mode === ThemeMode.DARK ? 'divider' : 'secondary' }
            }
          }}
        >
          <ListItemText
            primary={
              <Typography variant="h6" sx={{ color: isSelected ? iconSelectedColor : textColor }}>
                {item.title}
              </Typography>
            }
          />
        </ListItemButton>
      </Box>
    </>
  );
}
